import { useMemo } from 'react';
import { Button } from '@asigna/kit';
import cx from 'classnames';
import { ModalCloseButton, SafeAvatar } from 'components';
import { useSafes } from 'store';
import { shortenAddress } from 'utils/helper';

import errorIcon from './utils/images/error.svg';
import linkIcon from './utils/images/link.svg';

interface Props {
  onClose: () => void;
  usedAddresses?: string[];
}

export const SubAccountErrorDialog = (props: Props) => {
  const { onClose, usedAddresses } = props;

  const { safes } = useSafes();

  const usedSafes = useMemo(() => {
    return usedAddresses?.map((address) => safes.find((safe) => safe.address === address));
  }, [usedAddresses]);

  return (
    <div className="flex flex-col gap-16 relative">
      <div className="flex items-center justify-between mb-8">
        <p className="text-r20"></p>
        <ModalCloseButton onClick={onClose} />
      </div>
      <div className="flex flex-col items-center">
        <div className="flex items-center justify-center border w-56 h-56 rounded-[56px] border-white-10 mb-16">
          <img src={errorIcon} alt="" />
        </div>
        <div className="text-r20 text-center mb-8">You can’t create Sub-Account</div>
        {usedSafes?.length && usedSafes.length > 1 && (
          <>
            <div className="text-r14 text-regular text-center">
              It is no longer possible to create sub-accounts for this setup, as these addresses are
              already taken by existing modules
            </div>
            <div className="h-[.5px] w-full bg-white-10 my-16" />
            <div className="flex flex-col gap-20 w-full mb-32">
              <div className="text-b14">Already used current configurations</div>
              <div className="flex flex-col ">
                {usedSafes?.map((safe, index) => {
                  return (
                    <div
                      key={safe?._id}
                      className={cx(
                        'flex items-center justify-between py-12',
                        index < usedSafes.length - 1 ? 'border-b border-black-4' : ''
                      )}
                    >
                      <div className="flex gap-12 items-center">
                        <div className="w-40 h-40 bg-white-10 rounded-[20px] flex justify-center items-center">
                          <SafeAvatar size="32px" address={safe?._id || ''} />
                        </div>
                        <span className="text-m13">{safe?.name}</span>
                      </div>

                      <a
                        className="flex items-center gap-8"
                        href={`/vault/${safe?.address}/dashboard`}
                      >
                        <span className="text-r13 text-regular">
                          {shortenAddress(safe?.address)}
                        </span>
                        <img src={linkIcon} alt="" />
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
        {usedAddresses?.length && usedAddresses.length === 1 && (
          <div className="text-r14 text-regular text-center mb-32">{usedAddresses[0]}</div>
        )}

        <Button onClick={onClose} message="Close" fullWidth colorType="secondary" />
      </div>
    </div>
  );
};
